import { useEffect, useState } from "react";
import api from "../api/axios.tsx";
import { Subscription } from "../types/subscription.tsx";

export const useSubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([] as Subscription[]);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = user?.id || ""; // Fallback to "default" if no user

  useEffect(() => {
    api
      .post("/subscriptions/filter", { id: "", userId })
      .then((response) => {
        const fetchedSubscriptions = response.data;
        setSubscriptions(fetchedSubscriptions);
      })
      .catch((error) => {
        console.error("Failed to fetch subscription:", error);
      });
  }, [userId]);

  const saveToStorage = (data: Subscription) => {
    api
      .post("/subscriptions/", { ...data, userId })
      .then((response) => {
        setSubscriptions([data, ...subscriptions]);
      })
      .catch((error) => {
        console.error("Failed to save subscription:", error);
      });
  };

  const addSubscription = (tx: Subscription) => {
    saveToStorage(tx);
  };

  const deleteSubscription = (id: string) => {
    api
      .delete(`/subscriptions/${id}`)
      .then((res) => {
        const updatedSubscriptions = subscriptions.filter((t) => t.id !== id);
        setSubscriptions(updatedSubscriptions);
      })
      .catch((error) => {
        console.error("Failed to delete subscription:", error);
      });
  };

  const updateSubscription = (updatedTx: Subscription) => {
    api
      .put(`/subscriptions/${updatedTx.id}`, updatedTx)
      .then((res) => {
        const updatedSubscriptions = subscriptions.map((tx) =>
          tx.id === updatedTx.id ? { ...tx, ...updatedTx } : tx
        );
        setSubscriptions(updatedSubscriptions);
      })
      .catch((error) => {
        console.error("Failed to update subscription:", error);
      });
  };

  return {
    subscriptions,
    addSubscription,
    deleteSubscription,
    updateSubscription,
  };
};
